import type { ThemeOptions } from '@mui/material'

import { MuiButton, MuiButtonBase, MuiIconButton } from './buttons'
import { MuiCheckbox } from './checkbox'
import { MuiFormHelperText, MuiInputAdornment, MuiInputLabel, MuiOutlinedInput } from './inputs'
import { MuiSwitch } from './switch'
import { MuiToggleButton, MuiToggleButtonGroup } from './toggleButton'

/**
 * The Redesigned components overrides.
 */

export const components: ThemeOptions['components'] = {
    MuiTooltip: {
        defaultProps: {
            arrow: true,
            slotProps: {
                popper: {
                    modifiers: [
                        {
                            name: 'preventOverflow',
                            options: {
                                // when tooltip text is too long, it should have padding,
                                // preventing it from being flush against the window edge
                                padding: 16,
                            },
                        },
                    ],
                },
            },
        },
        styleOverrides: {
            tooltip: ({ theme }) => ({
                ...theme.typography.body2,
                backgroundColor: theme.palette.grey[900],
                padding: theme.spacing(1.5, 3),
            }),
            arrow: ({ theme }) => ({
                color: theme.palette.grey[900],
            }),
            popper: {
                '&[data-popper-placement*="bottom"]': {
                    // overrides popper offsets
                    inset: '-5px auto auto 1px !important',
                },
            },
        },
    },
    MuiButtonBase,
    MuiButton,
    MuiIconButton,
    MuiSwitch,
    MuiCheckbox,
    MuiToggleButton,
    MuiToggleButtonGroup,
    MuiInputLabel,
    MuiOutlinedInput,
    MuiFormHelperText,
    MuiInputAdornment,
}
